/* istanbul ignore file */

import styled from 'styled-components'

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${props => props.theme.colors.background.primary};
  border-radius: ${props => props.theme.primitives.radius.radius2};
  cursor: pointer;

  &:hover {
    background-color: ${props => props.theme.colors.disabled.surface};
  }
`

export const Content = styled.div`
  flex: 1;
  padding: ${props => props.theme.spacing.sp16};
`

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`

export const ChartContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

export const ChartWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  position: relative;
`

export const ChartCenter = styled.div`
  position: absolute;
  text-align: center;
`
